var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenverification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4997_25624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9328 3.33202C12.0701 3.66403 12.3336 3.92794 12.6654 4.06572L13.8288 4.54766C14.1609 4.6852 14.4247 4.949 14.5622 5.28105C14.6998 5.61309 14.6998 5.98617 14.5622 6.31822L14.0806 7.48088C13.943 7.81308 13.9428 8.18654 14.0811 8.51854L14.5618 9.68088C14.63 9.84534 14.6651 10.0216 14.6651 10.1996C14.6652 10.3777 14.6301 10.5539 14.562 10.7184C14.4938 10.8829 14.394 11.0323 14.2681 11.1582C14.1422 11.2841 13.9927 11.3839 13.8282 11.452L12.6656 11.9336C12.3336 12.0709 12.0697 12.3344 11.9319 12.6662L11.45 13.8297C11.3124 14.1617 11.0487 14.4255 10.7166 14.5631C10.3846 14.7006 10.0116 14.7006 9.6795 14.5631L8.5169 14.0815C8.18483 13.9443 7.8119 13.9445 7.4801 14.0823L6.31662 14.5635C5.98478 14.7007 5.61204 14.7006 5.28028 14.5632C4.94852 14.4257 4.68486 14.1623 4.54724 13.8306L4.06518 12.6667C3.9279 12.3347 3.66439 12.0708 3.3326 11.933L2.16914 11.4511C1.83725 11.3136 1.57354 11.0499 1.43595 10.7181C1.29837 10.3863 1.29818 10.0133 1.43543 9.68134L1.917 8.51874C2.0542 8.18668 2.05392 7.81374 1.91623 7.48188L1.43534 6.31753C1.36716 6.15308 1.33206 5.9768 1.33203 5.79876C1.332 5.62074 1.36705 5.44444 1.43518 5.27996C1.5033 5.11549 1.60317 4.96604 1.72908 4.84018C1.85498 4.71431 2.00444 4.61449 2.16894 4.54641L3.33156 4.06482C3.66328 3.92766 3.92702 3.66448 4.0649 3.33305L4.54682 2.16955C4.68435 1.8375 4.94815 1.5737 5.28018 1.43616C5.61221 1.29862 5.98528 1.29862 6.31731 1.43616L7.4799 1.91776C7.81196 2.05495 8.1849 2.05467 8.51676 1.91698L9.6807 1.43691C10.0127 1.29945 10.3856 1.29948 10.7176 1.43699C11.0496 1.5745 11.3134 1.83823 11.4509 2.17018L11.933 3.33403L11.9328 3.33202Z",
    fill: "#28B116",
    stroke: "#28B116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00016L7.33333 9.3335L10.3333 6.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4997_25624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenverification);
export default __webpack_public_path__ + "static/media/greenverification.d0047abb9479bf2f4a36d783b2b29618.svg";
export { ForwardRef as ReactComponent };